/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CrmProjectSubscriptionData
 */
export interface CrmProjectSubscriptionData {
    /**
     * 
     * @type {string}
     * @memberof CrmProjectSubscriptionData
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectSubscriptionData
     */
    packageId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectSubscriptionData
     */
    packageCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectSubscriptionData
     */
    packageName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectSubscriptionData
     */
    billingCycle?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CrmProjectSubscriptionData
     */
    packageNetPrice?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectSubscriptionData
     */
    packageCurrency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectSubscriptionData
     */
    status?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CrmProjectSubscriptionData
     */
    startDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CrmProjectSubscriptionData
     */
    endDate?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof CrmProjectSubscriptionData
     */
    isFreeTrial?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CrmProjectSubscriptionData
     */
    cancelAtPeriodEnd?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectSubscriptionData
     */
    nextPackageId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectSubscriptionData
     */
    nextBillingCycle?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CrmProjectSubscriptionData
     */
    paymentFailedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CrmProjectSubscriptionData
     */
    paymentGraceEndsAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CrmProjectSubscriptionData
     */
    paidAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectSubscriptionData
     */
    nextPackageName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectSubscriptionData
     */
    nextPackageCode?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CrmProjectSubscriptionData
     */
    nextPackageNetPrice?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CrmProjectSubscriptionData
     */
    nextPackageCurrency?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CrmProjectSubscriptionData
     */
    nextEffectiveAt?: Date | null;
}

/**
 * Check if a given object implements the CrmProjectSubscriptionData interface.
 */
export function instanceOfCrmProjectSubscriptionData(value: object): value is CrmProjectSubscriptionData {
    return true;
}

export function CrmProjectSubscriptionDataFromJSON(json: any): CrmProjectSubscriptionData {
    return CrmProjectSubscriptionDataFromJSONTyped(json, false);
}

export function CrmProjectSubscriptionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrmProjectSubscriptionData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] === undefined ? undefined : json['id'] === null ? null : json['id'],
        'packageId': json['packageId'] === undefined ? undefined : json['packageId'] === null ? null : json['packageId'],
        'packageCode': json['packageCode'] === undefined ? undefined : json['packageCode'] === null ? null : json['packageCode'],
        'packageName': json['packageName'] === undefined ? undefined : json['packageName'] === null ? null : json['packageName'],
        'billingCycle': json['billingCycle'] === undefined ? undefined : json['billingCycle'] === null ? null : json['billingCycle'],
        'packageNetPrice': json['packageNetPrice'] === undefined ? undefined : json['packageNetPrice'] === null ? null : json['packageNetPrice'],
        'packageCurrency': json['packageCurrency'] === undefined ? undefined : json['packageCurrency'] === null ? null : json['packageCurrency'],
        'status': json['status'] === undefined ? undefined : json['status'] === null ? null : json['status'],
        'startDate': json['startDate'] === undefined ? undefined : json['startDate'] === null ? null : (new Date(json['startDate'])),
        'endDate': json['endDate'] === undefined ? undefined : json['endDate'] === null ? null : (new Date(json['endDate'])),
        'isFreeTrial': json['isFreeTrial'] === undefined ? undefined : json['isFreeTrial'] === null ? null : json['isFreeTrial'],
        'cancelAtPeriodEnd': json['cancelAtPeriodEnd'] === undefined ? undefined : json['cancelAtPeriodEnd'] === null ? null : json['cancelAtPeriodEnd'],
        'nextPackageId': json['nextPackageId'] === undefined ? undefined : json['nextPackageId'] === null ? null : json['nextPackageId'],
        'nextBillingCycle': json['nextBillingCycle'] === undefined ? undefined : json['nextBillingCycle'] === null ? null : json['nextBillingCycle'],
        'paymentFailedAt': json['paymentFailedAt'] === undefined ? undefined : json['paymentFailedAt'] === null ? null : (new Date(json['paymentFailedAt'])),
        'paymentGraceEndsAt': json['paymentGraceEndsAt'] === undefined ? undefined : json['paymentGraceEndsAt'] === null ? null : (new Date(json['paymentGraceEndsAt'])),
        'paidAt': json['paidAt'] === undefined ? undefined : json['paidAt'] === null ? null : (new Date(json['paidAt'])),
        'nextPackageName': json['nextPackageName'] === undefined ? undefined : json['nextPackageName'] === null ? null : json['nextPackageName'],
        'nextPackageCode': json['nextPackageCode'] === undefined ? undefined : json['nextPackageCode'] === null ? null : json['nextPackageCode'],
        'nextPackageNetPrice': json['nextPackageNetPrice'] === undefined ? undefined : json['nextPackageNetPrice'] === null ? null : json['nextPackageNetPrice'],
        'nextPackageCurrency': json['nextPackageCurrency'] === undefined ? undefined : json['nextPackageCurrency'] === null ? null : json['nextPackageCurrency'],
        'nextEffectiveAt': json['nextEffectiveAt'] === undefined ? undefined : json['nextEffectiveAt'] === null ? null : (new Date(json['nextEffectiveAt'])),
    };
}

export function CrmProjectSubscriptionDataToJSON(json: any): CrmProjectSubscriptionData {
    return CrmProjectSubscriptionDataToJSONTyped(json, false);
}

export function CrmProjectSubscriptionDataToJSONTyped(value?: CrmProjectSubscriptionData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'packageId': value['packageId'],
        'packageCode': value['packageCode'],
        'packageName': value['packageName'],
        'billingCycle': value['billingCycle'],
        'packageNetPrice': value['packageNetPrice'],
        'packageCurrency': value['packageCurrency'],
        'status': value['status'],
        'startDate': value['startDate'] == null ? value['startDate'] : value['startDate'].toISOString(),
        'endDate': value['endDate'] == null ? value['endDate'] : value['endDate'].toISOString(),
        'isFreeTrial': value['isFreeTrial'],
        'cancelAtPeriodEnd': value['cancelAtPeriodEnd'],
        'nextPackageId': value['nextPackageId'],
        'nextBillingCycle': value['nextBillingCycle'],
        'paymentFailedAt': value['paymentFailedAt'] == null ? value['paymentFailedAt'] : value['paymentFailedAt'].toISOString(),
        'paymentGraceEndsAt': value['paymentGraceEndsAt'] == null ? value['paymentGraceEndsAt'] : value['paymentGraceEndsAt'].toISOString(),
        'paidAt': value['paidAt'] == null ? value['paidAt'] : value['paidAt'].toISOString(),
        'nextPackageName': value['nextPackageName'],
        'nextPackageCode': value['nextPackageCode'],
        'nextPackageNetPrice': value['nextPackageNetPrice'],
        'nextPackageCurrency': value['nextPackageCurrency'],
        'nextEffectiveAt': value['nextEffectiveAt'] == null ? value['nextEffectiveAt'] : value['nextEffectiveAt'].toISOString(),
    };
}

